import { render, staticRenderFns } from "./PickerYear.vue?vue&type=template&id=23ffa286&"
import script from "./PickerYear.vue?vue&type=script&lang=js&"
export * from "./PickerYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports